export default [
  // {
  //   title: "แผนประกันการเดินทางระหว่างประเทศ (รายเดี่ยว) - Eco",
  //   link: require("../../../static/pdf-template/International.pdf"),
  //   file_name: "ใบสมัครประกันเดินทางต่างประเทศ.pdf.pdf"
  // },
  // {
  //   title: "แผนประกันการเดินทางระหว่างประเทศ (รายเดี่ยว) - Best",
  //   link: require("../../../static/pdf-template/International.pdf"),
  //   file_name: "ใบสมัครประกันเดินทางต่างในประเทศ.pdf"
  // },
  // {
  //   title: "แผนประกันการเดินทางระหว่างประเทศ (รายเดี่ยว) - Good",
  //   link: require("../../../static/pdf-template/International.pdf"),
  //   file_name: "ใบสมัครประกันเดินทางต่างในประเทศ.pdf"
  // },
  {
    title: "แผนประกันการเดินทางระหว่างประเทศ (ครอบครัว) - Eco Plus",
    link: require("../../../static/pdf-template/International.pdf"),
    file_name: "ใบสมัครประกันเดินทางต่างในประเทศ.pdf"
  },
  {
    title: "แผนประกันการเดินทางระหว่างประเทศ (ครอบครัว) - Best",
    link: require("../../../static/pdf-template/International.pdf"),
    file_name: "ใบสมัครประกันเดินทางต่างในประเทศ.pdf"
  }
]